import React, { Fragment, FunctionComponent } from 'react'
import { Card } from '../../components/card'
import { utcToLocalDate } from '../../helpers/timeHelper'
import { User } from '../../core/types'

export interface Props {
  user: User
}

const UserUnderwriting: FunctionComponent<Props> = ({ user }) => {
  const { currentPurchaseLoan, currentRefiLoan } = user
  const purchase = currentPurchaseLoan
  const refi = currentRefiLoan

  const renderUnderwriteable = (underwritable, type) => {
    if (!underwritable) return null

    const qualifiedAtLabel = {
      Purchase: 'Prequal date',
      Refi: 'Approval date',
    }[type]

    const fields = [
      {
        label: qualifiedAtLabel,
        value:
          underwritable.qualifiedAt &&
          utcToLocalDate(underwritable.qualifiedAt),
      },
      { label: 'Decision', value: underwritable.decision },
      { label: 'Loan status', value: underwritable.status },
      { label: 'Credit tier', value: underwritable.tier },
      { label: 'Days to expiration', value: underwritable.daysToExpiration },
    ]
      .filter(({ value }) => value)
      .map(({ label, value }) => (
        <p className="user-underwriting__content" key={label}>
          {label}: {value}
        </p>
      ))

    return (
      <Fragment>
        <h3 className="user-underwriting__type">{type}:</h3>
        {fields}
      </Fragment>
    )
  }

  const renderEmpty = (purchase, refi) => {
    if (refi || purchase) return null

    return (
      <div className="user-underwriting__empty">
        <span className="user-underwriting__clippy-icon icon-clippy" />
        <p>No summary available</p>
      </div>
    )
  }

  return (
    <Card title="Underwriting summary" gridClass="user-underwriting">
      {renderUnderwriteable(purchase, 'Purchase')}
      {renderUnderwriteable(refi, 'Refi')}
      {renderEmpty(purchase, refi)}
    </Card>
  )
}

UserUnderwriting.displayName = 'UserUnderwriting'

export default UserUnderwriting
